export default __webpack_public_path__ + "static/ego-06c334779e7d1781c0cf6dd8626dc05e.svg";